import { Box } from '@mui/material';
import LabelList from '../utils/labelList';
import { Handle, Position } from '@xyflow/react';

const SquareShape = ({ data }) => {
	return (
		<Box
			sx={{
				width: 80,
				height: 80,
				// display: 'flex',
				display: 'none',
				color: '#fff',
				fontWeight: 500,
				borderRadius: '4px',
				alignItems: 'center',
				background: '#1976D2',
				justifyContent: 'center',
				border: '1px solid #1976D2',
			}}
		>
			{LabelList?.[data.label] ?? data?.label}

			{(data.mode === 'input' || data.mode === 'both') && <Handle type="source" position={Position.Right} isConnectable={!data?.locked} />}
			{(data.mode === 'output' || data.mode === 'both') && <Handle type="target" position={Position.Left} isConnectable={!data?.locked} />}
		</Box>
	);
};

export default SquareShape;
